
import Vue from 'vue'
import HomepageHeader from '@/components/homepage/HomepageHeader.vue'
export default Vue.extend({
  components: {
    HomepageHeader
  },
})
